import { styled } from '@mui/material'

export const EditorWrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  '&.error': {
    '.jodit-container:not(.jodit_inline)': {
      borderColor: theme.palette.error.main,
    },
  },

  '.jodit-placeholder': {
    padding: 16,
  },

  /* Hide Jodit placeholder when the editor already has content (fixes edit-load overlap). */
  '.jodit-container_not_empty .jodit-placeholder': {
    display: 'none !important',
  },
  '.jodit-wysiwyg:not(.jodit-wysiwyg_empty) ~ .jodit-placeholder': {
    display: 'none !important',
  },

  '.jodit-container:not(.jodit_inline)': {
    borderColor: '1px solid rgba(137, 146, 169, 0.2)',
    borderRadius: 10,
    overflow: 'hidden',
  },

  '.jodit-toolbar-button button': {
    minHeight: 'unset',
    height: 24,
  },

  '.jodit-toolbar-button': {
    height: 24,
    margin: '12px 1px',
  },

  '.jodit-ui-separator': {
    height: 24,
    borderColor: 'rgba(137, 146, 169, 0.2)',
  },

  '.jodit-ui-group': {
    alignItems: 'center',
    backgroundColor: '#fff',
  },

  '.jodit-icon': {
    stroke: theme.palette.text.secondary,
    color: theme.palette.text.secondary,
    fill: theme.palette.text.secondary,
  },

  '.jodit-wysiwyg': {
    color: theme.palette.text.primary,
  },

  '.jodit-container:not(.jodit_inline) .jodit-wysiwyg': {
    padding: 16,
  },

  '.jodit-toolbar-button__button:hover:not([disabled])': {
    backgroundColor: 'unset',

    '.jodit-icon': {
      stroke: theme.palette.text.primary,
      color: theme.palette.text.primary,
      fill: theme.palette.text.primary,
    },
  },

  /* Custom Jodit table resize overlays (row + column) */
  '.jodit-workplace': {
    position: 'relative',
  },

  '.jodit-tashkec-table-row-resizer': {
    position: 'absolute',
    zIndex: 4,
    height: 3,
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
    cursor: 'row-resize',
    borderRadius: 2,
    backgroundColor: 'rgba(30, 136, 229, 0.28)',
    border: '1px solid rgba(30, 136, 229, 0.45)',
    pointerEvents: 'auto',
    touchAction: 'none',
  },

  '.jodit-tashkec-table-row-resizer:hover': {
    backgroundColor: 'rgba(30, 136, 229, 0.42)',
  },

  '.jodit-tashkec-table-row-resizer_moved': {
    backgroundColor: 'rgba(30, 136, 229, 0.55)',
    borderColor: theme.palette.primary.main,
  },

  '.jodit-tashkec-table-col-resizer': {
    position: 'absolute',
    zIndex: 4,
    width: 3,
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
    cursor: 'col-resize',
    borderRadius: 2,
    backgroundColor: 'rgba(30, 136, 229, 0.55)',
    border: '1px solid rgba(30, 136, 229, 0.45)',
    pointerEvents: 'auto',
    touchAction: 'none',
  },

  '.jodit-tashkec-table-col-resizer:hover': {
    backgroundColor: 'rgba(30, 136, 229, 0.55)',
  },

  '.jodit-tashkec-table-col-resizer_moved': {
    backgroundColor: 'rgba(30, 136, 229, 0.55)',
    borderColor: theme.palette.secondary?.main ?? '#9c27b0',
  },
}))
